document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.testimonial-slider').forEach(function (slider) {

    new Swiper(slider, {

      // Infinite carousel
      loop: true,

      // Mouse + touch dragging
      grabCursor: true,
      simulateTouch: true,

      // Smooth movement
      speed: 600,

      // Desktop
      slidesPerView: 4,
      spaceBetween: 24,

      // Dots
      pagination: {
        el: slider.querySelector('.testimonial-pagination'),
        clickable: true,
      },

      // Responsive
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 15
        },

        750: {
          slidesPerView: 2,
          spaceBetween: 20
        },

        990: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }

    });

  });
});